<template>
  <Modal
    v-model="_value"
    width="500"
    title='短信RM设置N9运维网络'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">

    <p>确认发送短信：锐明设备设置N9运维网络</p>

  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setuprmsnywsmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        simNum:null,

      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onOk() {

        //共三条短信，对应不同密码
        // console.log(this.simNum.substring(6))

          this.sendSMS('99admin,admin,SNYW47.112.119.125,8100,2!')

          setTimeout(() => {
              this.sendSMS('99admin,JC336699,SNYW47.112.119.125,8100,2!')
            }
            ,5000)

          setTimeout(() => {
              this.sendSMS('99admin,,SNYW47.112.119.125,8100,2!')
            }
            ,10000)

      },
      sendSMS (content) {
        if (!this.simNum || this.simNum === '') {
          this.$Message.error('请选择SIM卡号')
          return
        }
        store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
